// extracted by mini-css-extract-plugin
export default {"hr":"b97327","hr--with-margin":"d8d4d7","hr--expanded":"b32ada"};